import type { Company, CompanyPurpose } from '@pn/core/domain/intel/company';
import { isNil } from 'lodash-es';
import type { ApiCompany } from './types';

export const apiCompanyMapper = {
  toDomainCompany: (apiIntelCompany: ApiCompany): Company => {
    if (isNil(apiIntelCompany)) {
      throw new Error('apiIntel is not a valid object');
    }

    return {
      id: apiIntelCompany.id.toString(),
      name: apiIntelCompany.display_name,
      legalName: apiIntelCompany.main_legal_name,
      aliases: apiIntelCompany.search_string_list,
      website: apiIntelCompany.website_hostname,
      hasIntelData: apiIntelCompany.has_intel_data,
      isLandBroker: apiIntelCompany.company_purpose === 'land_broker',
      isDataPublic: apiIntelCompany.is_data_public,
      boeReportLink: apiIntelCompany.boe_report_link,
      isDefunct: apiIntelCompany.is_defunct,
      purpose: apiIntelCompany.company_purpose as CompanyPurpose,
      ...(!isNil(apiIntelCompany.stock_symbol) && {
        stockSymbol: apiIntelCompany.stock_symbol,
      }),
    };
  },
  toTargetCompany: (domainCompany: Company): ApiCompany => {
    if (isNil(domainCompany)) {
      throw new Error('domainCompany is not a valid object');
    }

    return {
      id: domainCompany.id,
      display_name: domainCompany.name,
      main_legal_name: domainCompany.legalName,
      search_string_list: domainCompany.aliases,
      website_hostname: domainCompany.website
        ? domainCompany.website
        : undefined,
      has_intel_data: domainCompany.hasIntelData,
      stock_symbol: domainCompany.stockSymbol ?? null,
      is_data_public: domainCompany.isDataPublic,
      boe_report_link: domainCompany.boeReportLink,
      is_defunct: domainCompany.isDefunct,
      company_purpose: domainCompany.purpose,
    };
  },
};
